import styled from 'styled-components';
import { config } from '../../../../../../../components/dashboards/config';

export default styled.div`
  width: 100%;
  padding: ${config.PADDING - 14}px ${config.PADDING - 5}px;
  overflow: auto;

  .subjects-container {
    display: flex;
    flex-wrap: wrap;

    .subject-container {
      display: flex;
      flex: 1;
      min-width: 150px;
      padding: 10px 5px;

      .section {
        display: flex;
        flex-direction: column;
        justify-content: center;
        white-space: nowrap;
        overflow: hidden;
      }

      .icon {
        width: 20px;
      }

      .value {
        padding-right: 8px;
        padding-left: 8px;
        text-align: right;
        color: var(--mmt-primary-70);

        span {
          font-size: 17px;
          font-weight: 700;
        }
      }

      .title {
        font-size: 14px;
        max-width: fit-content;
        color: #595959;
      }
    }
  }
`;
